import React from 'react';
import Icon from '../../../components/AppIcon';

const SummaryCard = ({ title, amount, currency, trend, trendValue, icon, iconColor, isPro, mtdAmount, lastMonthAmount, netChange, netChangePercent }) => {
  const isPositive = trend === 'up';
  const trendIcon = isPositive ? 'TrendingUp' : 'TrendingDown';
  const trendColor = isPositive ? 'text-success' : 'text-error';

  return (
    <div className="bg-card rounded-lg p-12 md:p-16 lg:p-20 shadow-elevation-2 hover:shadow-elevation-3 transition-smooth">
      <div className="flex items-start justify-between mb-12">
        <div className="flex items-center">
          <div
            className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-lg transition-smooth"
            style={{ backgroundColor: `${iconColor}15` }}>
            <Icon name={icon} size={20} color={iconColor} strokeWidth={2.5} />
          </div>
          <h3 className="ml-8 text-xs md:text-sm lg:text-base font-caption font-medium text-muted-foreground">
            {title}
          </h3>
        </div>
      </div>
      <div className="flex items-end justify-between">
        <div>
          <p className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-card-foreground">
            {currency}{typeof amount === 'number' ? amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : amount}
            {!currency && typeof amount === 'number' && '%'}
          </p>
          {trendValue > 0 && (
            <div className={`flex items-center mt-6 ${trendColor}`}>
              <Icon name={trendIcon} size={14} strokeWidth={2.5} />
              <span className="ml-4 text-xs font-caption font-medium">
                {trendValue?.toFixed(1)}% vs last month
              </span>
            </div>
          )}
          
          {/* Pro-only: Month-to-date comparison */}
          {isPro && mtdAmount !== undefined && (
            <div className="mt-8 pt-8 border-t border-border">
              <p className="text-xs text-muted-foreground mb-4">Month-to-date</p>
              <p className="text-sm font-semibold text-foreground">
                {currency}{mtdAmount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </p>
            </div>
          )}

          {/* Pro-only: Net change indicator */}
          {isPro && netChange !== undefined && (
            <div className="mt-8 pt-8 border-t border-border">
              <p className="text-xs text-muted-foreground mb-4">Net Change</p>
              <div className="flex items-center gap-6">
                <p className={`text-sm font-semibold ${
                  netChange >= 0 ? 'text-success' : 'text-error'
                }`}>
                  {netChange >= 0 ? '+' : ''}{currency}{netChange?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
                {netChangePercent !== 0 && (
                  <span className={`text-xs px-4 py-2 rounded-full ${
                    netChangePercent >= 0 ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
                  }`}>
                    {netChangePercent >= 0 ? '+' : ''}{netChangePercent?.toFixed(0)}%
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryCard;